import {KompisDefaultFields, ProductService} from "@inter-ikea-kompis/services"
import {
  IDexfSettings,
  IShoppingItem,
  IShoppingProduct,
} from "@inter-ikea-kompis/types"
import {getLocale} from "./LocaleHelper"

export default class ProductConfiguration {
  public getShoppingProducts(
    shoppingList: IShoppingItem[],
    dexfSettings: IDexfSettings
  ): Promise<IShoppingProduct[]> {
    const productService = new ProductService({
      // Localization service settings
      locale: getLocale(),

      // DEXF application ID used when storing and loading VPC configurations from DEXF.
      // Will fallback to "applicationName" if not specified.
      dexfApplicationId: "DEKIS",

      settings: dexfSettings,

      dexfApiKey: "ed299ee2-a032-4b71-8e9d-75c74144d1d6",
    })
    return productService.getShoppingProducts(shoppingList, KompisDefaultFields)
  }
}
